export default {
  SUBSCRIPTIONS: {
    title: 'about_subscription',
    code: 'subscription',
    content: [
      // {
      //   question: 'ACworks projects and services',
      //   answer:
      //     'Currently, we provide users with the following services:</br></br><b>Registration required:</b> to download resources on our registration-required sites, you must have an account.</br><a target="_blank" href="https://www.ac-illust.com">https://www.ac-illust.com</a> (For vectors and illustrations)</br><a target="_blank" href="https://www.photo-ac.com">https://www.photo-ac.com</a> (For stock photos)</br><a target="_blank" href="https://www.silhouette-ac.com">https://www.silhouette-ac.com</a> (For silhouettes)</br><a target="_blank" href="https://template-ac.com">https://template-ac.com</a> (For templates)</br></br><b>Non-registration required:</b> you don\'t need to sign up for any account for our non-registration sites</br><a target="_blank" href="https://www.design-ac.net/en">https://www.design-ac.net</a> (For design tool)</br><a target="_blank" href="https://ac-data.info/en">https://ac-data.info</a> (For data transfer)</br><a target="_blank" href="https://compressor-ac.net/?gt=1#googtrans(en)">https://compressor-ac.net</a> (For image compression)</br><a target="_blank" href="https://www.photo-ac.com/en/genface">https://www.photo-ac.com/en/genface</a> (For AI generated face photos)</br><a target="_blank" href="https://ac-artist.com/?gt=1#googtrans(en)">https://ac-artist.com</a> (For art image creation)</br><a target="_blank" href="https://ac-beautify.com/?gt=1#googtrans(en)">https://ac-beautify.com</a> (For photo enhancement)</br><a target="_blank" href="https://scoring-ac.com/?gt=1#googtrans(en)">https://scoring-ac.com</a> (For photo evaluation)</br><a target="_blank" href="https://fusion-ac.net/?gt=1#googtrans(en)">https://fusion-ac.net</a> (For face replacement)',
      // },

      {
        question: 'subscription_question_1',

        answer: 'subscription_answer_1',
      },
      {
        question: 'subscription_question_2',

        answer: 'subscription_answer_2',
      },
      {
        question: 'subscription_question_3',

        answer: 'subscription_answer_3',
      },
      {
        question: 'subscription_question_4',

        answer: 'subscription_answer_4',
      },
      {
        question: 'subscription_question_5',

        answer: 'subscription_answer_5',
      },
      {
        question: 'subscription_question_6',

        answer: 'subscription_answer_6',
      },
      {
        question: 'subscription_question_7',

        answer: 'subscription_answer_7',
      },
    ],
  },
  PAYMENT_AND_BILL: {
    title: 'about_payment_and_bill',
    code: 'payment_and_bill',
    content: [
      {
        question: 'payment_and_bill_question_1',

        answer: 'payment_and_bill_answer_1',
      },
      {
        question: 'payment_and_bill_question_2',

        answer: 'payment_and_bill_answer_2',
      },
      {
        question: 'payment_and_bill_question_3',

        answer: 'payment_and_bill_answer_3',
      },
      {
        question: 'payment_and_bill_question_4',

        answer: 'payment_and_bill_answer_4',
      },
    ],
  },
  TECHNICAL_SUPPORT: {
    title: 'about_technical_support',
    code: 'technical_support',
    content: [
      {
        question: 'technical_support_question_1',

        answer: 'technical_support_answer_1',
      },
      {
        question: 'technical_support_question_2',

        answer: 'technical_support_answer_2',
      },
      {
        question: 'technical_support_question_3',

        answer: 'technical_support_answer_3',
      },
      {
        question: 'technical_support_question_4',

        answer: 'technical_support_answer_4',
        button_cancel: true,
        button_delete: false,
        show_link: false,
        link: 'help_page_link1',
        end: 'help_page_thanks1',
      },
      {
        question: 'technical_support_question_5',

        answer: 'technical_support_answer_5',
        button_cancel: false,
        button_delete: true,
        show_link: false,
        link: 'help_page_link2',
        end: 'help_page_thanks2',
      },
      {
        question: 'technical_support_question_6',

        answer: 'technical_support_answer_6',
      },
      {
        question: 'technical_support_question_7',

        answer: 'technical_support_answer_7',
      },
      {
        question: 'technical_support_question_8',

        answer: 'technical_support_answer_8',
      },
      // {
      //   question: 'technical_support_question_9',

      //   answer: 'technical_support_answer_9',
      // },
      {
        question: 'technical_support_question_10',

        answer: 'technical_support_answer_10',
      },
    ],
  },
  USAGE_GUIDES: {
    title: 'about_usage_guides',
    code: 'usage_guides',
    content: [
      {
        question: 'usage_guides_question_1',
        answer: 'usage_guides_answer_1',
      },
      {
        question: 'usage_guides_question_2',
        answer: 'usage_guides_answer_2',
      },
      {
        question: 'usage_guides_question_3',
        answer: 'usage_guides_answer_3',
      },
      {
        question: 'usage_guides_question_4',
        answer: 'usage_guides_answer_4',
      },
      {
        question: 'usage_guides_question_5',
        answer: 'usage_guides_answer_5',
      },
      {
        question: 'usage_guides_question_6',
        answer: 'usage_guides_answer_6',
      },
      {
        question: 'usage_guides_question_7',
        answer: 'usage_guides_answer_7',
      },
      {
        question: 'usage_guides_question_8',
        answer: 'usage_guides_answer_8',
      },
      {
        question: 'usage_guides_question_9',
        answer: 'usage_guides_answer_9',
      },
      {
        question: 'usage_guides_question_10',
        answer: 'usage_guides_answer_10',
      },
      {
        question: 'usage_guides_question_11',
        answer: 'usage_guides_answer_11',
      },
      {
        question: 'usage_guides_question_12',
        answer: 'usage_guides_answer_12',
      },
      {
        question: 'usage_guides_question_13',
        answer: 'usage_guides_answer_13',
      },
      {
        question: 'usage_guides_question_14',
        answer: 'usage_guides_answer_14',
      },
    ],
  },
};
